import { styled } from '@mui/material/styles';

export const Container = styled('div')({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    padding: '0 24px',
    '@media (max-width: 420px)': { padding: 0 },
});

export const Header = styled('div')({
    width: '100%',
    maxWidth: 380,
    display: 'flex',
    justifyContent: 'center',
});

export const PhoneFrame = styled('div')({
    width: '100%',
    maxWidth: 380,
    backgroundColor: '#fff',
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.10)',
});

const AvatarRoot = styled('div', { shouldForwardProp: p => p !== 'size' && p !== 'color' })(
    ({ size = 40, color = '#999' }) => ({
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        fontSize: Math.round(size * 0.42),
        flexShrink: 0,
        overflow: 'hidden',
        textTransform: 'uppercase',
    }),
);

const AvatarImg = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
});

const initialOf = name => (name || '?').trim().charAt(0).toUpperCase();

export const BrandAvatar = ({ name, image, size = 40, color = '#999', className, style }) => (
    <AvatarRoot size={size} color={color} className={className} style={style}>
        {image ? <AvatarImg src={image} alt="" /> : initialOf(name)}
    </AvatarRoot>
);
